import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {Trans} from '@common/i18n/trans';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@common/ui/overlays/dialog/dialog-context';
import {useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import {DialogFooter} from '@common/ui/overlays/dialog/dialog-footer';
import {Button} from '@common/ui/buttons/button';
import {
  UpdateCategoryPayload,
  useUpdateCategory,
} from '@app/blog/category/use-update-category';
import {Category} from '@app/blog/category/category';
import React, {Fragment} from 'react';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';

interface Props {
  category: Category;
}
export function UpdateCategoryDialog({category}: Props) {
  const {formId, close} = useDialogContext();
  const form = useForm<UpdateCategoryPayload>({
    defaultValues: {
      name: category.name,      
    },
  });
  const updateCategory = useUpdateCategory(category.id, form);
  return (
    <Dialog>
      <DialogHeader>
        <Trans message="Update category" />
      </DialogHeader>
      <DialogBody>
        <Form
          id={formId}
          form={form}
          onSubmit={value => {
            updateCategory.mutate(value, {
              onSuccess: () => close(),
            });
          }}
        >
          <Fragment>
            <FormTextField
              autoFocus
              name="name"
              label={<Trans message="Name" />}
              className="mb-14"
              required
            />
          </Fragment>
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Cancel" />
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="flat"
          color="primary"
          disabled={updateCategory.isPending}
        >
          <Trans message="Update" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
